import React from "react";

function DirectorMessage() {
  return (
    <section className="director">
      <p className="quote">
        "At SimpliConnect, we believe the future of work is defined by the
        quality of the connection. We pride ourselves on transparency and
        a 'client-first' mindset, ensuring every hire feels like a seamless
        extension of your local team."
      </p>

      <h4>— Romesh Pushkaran</h4>
      <p>Director of Operations</p>
    </section>
  );
}

export default DirectorMessage;